export const formatHtmlContent = (html: string): string => {
  return html
    .replace(/<p[^>]*>\s*<br\s*\/?>\s*<\/p>/g, '<br />')
    .replace(/<\/p>/g, '</p><br />')
}
